import React from "react";
import { SubscriptionIntervalType } from "@jugl-web/rest-api/entities/models/common-types/SubscriptionIntervalType";
import { LiquidGlass } from "@liquidglass/react";
import "./SubscriptionIntervals.css";

interface SubscriptionIntervalsProps {
  intervals: {
    label: string;
    value: SubscriptionIntervalType;
    annotation?: string;
  }[];
  selectedInterval: SubscriptionIntervalType;
  onIntervalChange: (interval: SubscriptionIntervalType) => void;
}

export const SubscriptionIntervals = ({
  intervals,
  selectedInterval,
  onIntervalChange,
}: SubscriptionIntervalsProps) => {
  return (
    <div className="rounded-[20px] border-[1px] border-solid border-white/50">
      <LiquidGlass
        brightness={2}
        blur={0.7}
        saturation={1}
        elasticity={0.6}
        displacementScale={0.6}
      >
        <div className="flex p-1">
          {intervals.map((interval) => (
            <div
              key={interval.value}
              className={`intervalButton ${
                selectedInterval === interval.value ? "selected" : ""
              }`}
              onClick={() => onIntervalChange(interval.value)}
            >
              {interval.label}
            </div>
          ))}
        </div>
      </LiquidGlass>
    </div>
  );
};
